(function($) {
	'use strict';

	/**
	 * Calculate average maturity scores for controls
	 * 
	 * This function processes project items and calculates average maturity scores
	 * for each control based on the unique control values mapping. It distributes
	 * maturity scores from project items to their corresponding controls and
	 * calculates the average score for each control.
	 * 
	 * @param {Array} projectItems - Array of project items with maturity scores
	 * @param {Object} uniqueControlValues - Object containing control mappings by standard
	 * @returns {Object} Object containing average scores for each control
	 */
	function calculateAverageMaturityScores(projectItems, uniqueControlValues) {
		const funcStartTime = performance.now();
		// console.log(`[${performance.now().toFixed(2)}] calculateAverageMaturityScores called with:`, {
		// 	projectItemsCount: projectItems?.length || 0,
		// 	uniqueControlValuesKeys: Object.keys(uniqueControlValues || {}),
		// 	uniqueControlValues
		// });

		const controlScores = {};
		const controlCounts = {};

		// console.log(`[${performance.now().toFixed(2)}] Starting control scores initialization...`);
		const initStartTime = performance.now();
		// Initialize control scores and count the unique safeguardIds for each controlId
		Object.keys(uniqueControlValues || {}).forEach(standard => {
			Object.keys(uniqueControlValues[standard]).forEach(controlId => {
				// Initialize the control if it hasn't been initialized yet
				if (!controlScores[controlId]) {
					controlScores[controlId] = 0;
					controlCounts[controlId] = new Set(); // Use a Set to track unique safeguard IDs
				}
				// Add all safeguardIds to the Set for the controlId
				uniqueControlValues[standard][controlId].forEach(safeguardId => {
					controlCounts[controlId].add(safeguardId);
				});
			});
		});

		// console.log(`[${performance.now().toFixed(2)}] Control scores initialization completed in ${(performance.now() - initStartTime).toFixed(2)}ms`);

		// Convert Sets to their sizes (count of unique safeguards)
		Object.keys(controlCounts).forEach(controlId => {
			controlCounts[controlId] = controlCounts[controlId].size;
		});

	// console.log(`[${performance.now().toFixed(2)}] Starting project items processing (${projectItems?.length || 0} items)...`);
	const processingStartTime = performance.now();
	
	// Debug: Check sample safeguard IDs from project items vs mappings
	const sampleProjectIds = projectItems.slice(0, 5).map(item => item.safeguardid.S);
	const sampleMappingIds = [];
	Object.keys(uniqueControlValues).forEach(standard => {
		Object.keys(uniqueControlValues[standard]).slice(0, 2).forEach(controlId => {
			sampleMappingIds.push(...uniqueControlValues[standard][controlId].slice(0, 2));
		});
	});
	// console.log('[DEBUG] Sample project safeguard IDs:', sampleProjectIds);
	// console.log('[DEBUG] Sample mapping safeguard IDs:', sampleMappingIds.slice(0, 10));
	
	const controlNaSafeguards = {};
	Object.keys(controlCounts).forEach(controlId => {
		controlNaSafeguards[controlId] = new Set();
	});

	let matchCount = 0;
	// Iterate through each project item
	projectItems.forEach(item => {
		const safeguardId = item.safeguardid.S;
		const maturityScore = item.maturityscore;
		const policyStatus = parseInt(item.policystatus.N, 10);
		const isNa = policyStatus === 1 || maturityScore === null;

		// Distribute scores to each control that contains the safeguardId
		Object.keys(uniqueControlValues).forEach(standard => {
			Object.keys(uniqueControlValues[standard]).forEach(controlId => {
				if (uniqueControlValues[standard][controlId].includes(safeguardId)) {
					matchCount++;

					if (isNa) {
						controlNaSafeguards[controlId].add(safeguardId);
					} else {
						if (controlScores[controlId] === undefined || controlScores[controlId] === null) {
							controlScores[controlId] = 0;
						}
						controlScores[controlId] += maturityScore;
					}
				}
			});
		});
	});
	// console.log(`[${performance.now().toFixed(2)}] Project items processing completed in ${(performance.now() - processingStartTime).toFixed(2)}ms`);
	// console.log(`[DEBUG] Total matches found: ${matchCount} out of ${projectItems?.length || 0} items`);

		// console.log(`[${performance.now().toFixed(2)}] Starting average scores calculation...`);
		const avgCalcStartTime = performance.now();
		// Calculate average scores, excluding N/A items from the denominator
		const averageScores = {};
		Object.keys(controlScores).forEach(controlId => {
			const naCount = controlNaSafeguards[controlId] ? controlNaSafeguards[controlId].size : 0;
			const effectiveCount = controlCounts[controlId] - naCount;
			if (effectiveCount > 0) {
				const score = controlScores[controlId] / effectiveCount;
				if (isNaN(score)) {
					averageScores[controlId] = 0;
				} else {
					averageScores[controlId] = score;
				}
			} else if (naCount > 0 && naCount >= controlCounts[controlId]) {
				// All items for this control are N/A - omit from results
			} else {
				averageScores[controlId] = 0;
			}
		});
		// console.log(`[${performance.now().toFixed(2)}] Average scores calculation completed in ${(performance.now() - avgCalcStartTime).toFixed(2)}ms`);

		// console.log("Average Scores inside calculateAverageMaturityScores:", averageScores);
		// console.log("Final averageScores before return:", averageScores);
		const totalFuncTime = performance.now() - funcStartTime;
		// console.log(`[${performance.now().toFixed(2)}] calculateAverageMaturityScores completed in ${totalFuncTime.toFixed(2)}ms total`);
		return averageScores;
	}

	// Export for use in other modules
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = { calculateAverageMaturityScores };
	} else if (typeof window !== 'undefined') {
		window.calculateAverageMaturityScores = calculateAverageMaturityScores;
	}

})(jQuery);
